import React from "react";
import { Table } from "react-bootstrap";

const ExtendedDerivedTable = ({ data }) => {
   if (!data || Object.keys(data).length === 0) {
      return <p style={{ fontSize: "14px" }}>No extended attributes available.</p>; // Handle empty data gracefully
   }

   return (
      <div style={{ maxHeight: "400px", overflowY: "auto" }}>
         {Object.keys(data).map((sectionHeader, index) => (
            <div key={index} style={{ marginBottom: "1px" }}>
               {/* Section Header */}
               <h6
                  style={{
                     background: "#EEEEEE",
                     textAlign: "left",
                     marginBottom: "10px",
                     fontWeight: "bold",
                     fontSize: "14px",
                     padding: "8px",
                  }}
               >
                  {sectionHeader}
               </h6>

               {/* Table */}
               <Table hover responsive style={{ fontSize: "12px" }}>
                  <tbody>
                     {Object.entries(data[sectionHeader]).map(([key, value], idx) => (
                        <tr key={idx}>
                           <td style={{ textAlign: "left", padding: "4px", width: "50%", fontWeight: "bold" }}>{key}</td>
                           <td style={{ textAlign: "left", padding: "4px", width: "50%" }}>{value}</td>
                        </tr>
                     ))}
                  </tbody>
               </Table>
            </div>
         ))}
      </div>
   );
};

export default ExtendedDerivedTable;